var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavPlanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.49999H17.5M6.66667 1.66666V4.16666M13.3333 1.66666V4.16666M5.83333 18.3333H14.1667C16.0076 18.3333 17.5 16.8409 17.5 15V6.24999C17.5 4.40904 16.0076 2.91666 14.1667 2.91666H5.83333C3.99238 2.91666 2.5 4.40904 2.5 6.24999V15C2.5 16.8409 3.99238 18.3333 5.83333 18.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavPlanned);
export default __webpack_public_path__ + "static/media/sidenav-planned.fe11e650d85857f6b66b029ee0939d9d.svg";
export { ForwardRef as ReactComponent };